The unique tracking token.

This token is generated by SEEK, and is associated with a given application.
Do not re-use this field across multiple applications.

Only applicable to application status updates for external applications.
